/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import Image from './../../../components/ZUILib/Image';
import InputButton from './../../../components/ZUILib/InputButton';
import * as labelsActions from '../../../components/labels/actions';
import ApplyCSS from '../../../components/ApplyCSS';
import commonUtil from '../../../utils/commonUtil';
import * as targetterActions from '../GiftRegistryhome/actions';
import AppEvents from './../../App/AppEvents';
import Tagging from '../../../components/Tagging/Tagging';
import serverClientUtil from '../../../utils/serverClientUtil';

const applicationRoutes = commonUtil.getApplicationRoutes();
const channel = commonUtil.getChannel();
const { isContentLoaded, loadContent } = targetterActions;
const { isLablesLoaded, loadLables } = labelsActions;
const constChannels = commonUtil.getClientConstForChannel();

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isContentLoaded(getState())) {
        return dispatch(loadContent());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
])
@connect(store => ({
  targetter: store.targetterContent.data,
  lables: store.labels.data,
  user: store.user.data,
}))

class ToolsForMyEvent extends Component {
  constructor(props) {
    super(props);
    this.redirectToCreateEventPage = this.redirectToCreateEventPage.bind(this);
  }
  UNSAFE_componentWillMount() {
    if (channel === constChannels.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
    }
  }
  componentDidMount() {
    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [commonUtil.defaultBrowserBackClick]);
    }

    // eslint-disable-next-line no-undef
    /* dataLayer.push({
      event: 'vPageView',
      GroupOne: window.location.pathname,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Herramientas para mi evento',
      Site: 'Mesa de Regalos',
    }); beforetag */

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'Home_Mesa_de_Regalos',
      selectOption: 'Home_Ver_mas_informacion',
    });
  }
  componentWillUnmount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }

  handleLoginWithAuth0 = () => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = 'https:' + url + '/login';
    // const redirectUrl = 'https://local.liverpool.com.mx:8443/tienda/login';
    const redirectBackUrl = `${window.location.origin}/crearevento/seleccioneeltipodemesa`;
    window.location.replace(`${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`);
  }

  redirectToCreateEventPage = () => {
    if (this.props && this.props.user && this.props.user.result && this.props.user.result.firstName) {
      browserHistory.push(applicationRoutes.createEvent);
    } else {
      this.handleLoginWithAuth0();
    }
  }
  render() {
    const { targetter } = this.props;
    const pageName = 'toolsForMyEvent';
    const _imgsrc1 = [
      {
        media: '(max-width: 60px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/09_pagina_web.svg',
      },
    ];

    const imageAttr1 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/09_pagina_web.svg',
      alt: 'Mountain view',
      width: 'auto',
      height: '60px',
    };
    const _imgsrc2 = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/guest/tools/website.jpg',
      },
    ];

    const imageAttr2 = {
      src: commonUtil.getAssetURL() + '/images/guest/tools/website.jpg',
      alt: 'Mountain view',
    };
    const _imgsrc3 = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/lista.png',
      },
    ];

    const imageAttr3 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/lista.png',
      alt: 'Mountain view',
      width: 'auto',
      height: 'auto',
    };
    const _imgsrc4 = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/cochi.png',
      },
    ];

    const imageAttr4 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/cochi.png',
      alt: 'Mountain view',
      width: 'auto',
      height: 'auto',
    };
    const _imgsrc8 = [
      {
        media: '(max-width: 60px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/invitacion.svg',
      },
    ];

    const imageAttr8 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/invitacion.svg',
      alt: 'Mountain view',
      width: 'auto',
      height: '60px',
    };
    const _imgsrc9 = [
      {
        media: '(max-width: 60px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/invitados.svg',
      },
    ];

    const imageAttr9 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/invitados.svg',
      alt: 'Mountain view',
      width: 'auto',
      height: '60px',
    };
    const _imgsrc10 = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/encuesta.png',
      },
    ];

    const imageAttr10 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/encuesta.png',
      alt: 'Mountain view',
      width: 'auto',
      height: 'auto',
    };
    const _imgsrc11 = [
      {
        media: '(max-width: 60px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/mesas.svg',
      },
    ];

    const imageAttr11 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/mesas.svg',
      alt: 'Mountain view',
      width: 'auto',
      height: '60px',
    };
    const _imgsrc12 = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/vino.png',
      },
    ];

    const imageAttr12 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/vino.png',
      alt: 'Mountain view',
      width: 'auto',
      height: 'auto',
    };
    const _imgsrc16 = [
      {
        media: '(max-width: 465px)',
        srcSet: commonUtil.getAssetURL() + '/images/admin/tools/cooperacha.png',
      },
    ];

    const imageAttr16 = {
      src: commonUtil.getAssetURL() + '/images/admin/tools/cooperacha.png',
      alt: 'Mountain view',
      width: 'auto',
      height: 'auto',
    };
    const webBtn = {
      type: 'button',
      value: 'Crear Mesa de Regalos',
      autoFocus: false,
      style: 'btnPrimary size-ExtraLarge',
      onClickHandler: this.redirectToCreateEventPage,
    };
    const wapBtn = {
      type: 'button',
      value: 'Crear Mesa de Regalos',
      autoFocus: false,
      style: 'btnPrimary size-Full',
      onClickHandler: this.redirectToCreateEventPage,
    };
    let eventTargetterValueWeb = '';
    let eventTargetterValueWap = '';
    const eventTargetterWeb = targetter && targetter.targeterContents && targetter.targeterContents.filter((target) => {
      const eventTargetterContentWeb = target.name === 'EventToolsGuestBannerContent_Web' ? target : null;
      return eventTargetterContentWeb;
    });
    if (eventTargetterWeb && eventTargetterWeb.length && eventTargetterWeb.length > 0) {
      eventTargetterValueWeb = eventTargetterWeb[0];
    }
    const eventTargetterWap = targetter && targetter.targeterContents && targetter.targeterContents.filter((target) => {
      const eventTargetterContentWap = target.name === 'EventToolsGuestBannerContent_Wap' ? target : null;
      return eventTargetterContentWap;
    });
    if (eventTargetterWap && eventTargetterWap.length && eventTargetterWap.length > 0) {
      eventTargetterValueWap = eventTargetterWap[0];
    }
    return (
      <React.Fragment>
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName={pageName} />
        {
          channel === 'web' ?
            <React.Fragment>
              {eventTargetterValueWeb && eventTargetterValueWeb.data ? <div dangerouslySetInnerHTML={{ __html: eventTargetterValueWeb.data }} /> : ''}

              <div className="row everyTool">
                <div className="col-sm-1" />
                <div className="col-sm-10">
                  <div className="toolsHome">
                    {/* <p className="mainText" style={{ fontSize: 18 }}><b>Todo para la planeación de tu gran evento.</b></p>
                    <p className="mainText" style={{ fontSize: 18 }}><b>Registra tu Mesa de Regalos ahora y de inmediato podras usar estas maravillosas herramientas para que tu evento sea perfecto, son gratuitas y fáciles de usar.</b></p> */}
                    <div className="toolsIntro">
                      <div className="websiteText">
                        <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />
                        <h1 className="titleSection">Página Web de mi evento</h1>
                        <p className="mainText greyBox">Construye tu propio sitio web para el gran evento, es fácil y rápido. Personalízalo, comparte información importante sobre el gran día, ¡sorprende a tus invitados!</p>
                      </div>
                      <div className="website">
                        <Image imageAttr={imageAttr2} _imgsrc={_imgsrc2} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr8} _imgsrc={_imgsrc8} />
                          <h2 className="subtitleSection divider">Invitación virtual</h2>
                          <p className="mainText greyBox">{commonUtil.getLabel(this.props.lables && this.props.lables.guestList, 'eventManagement.anonymous.virtualInvitation.description')}</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr9} _imgsrc={_imgsrc9} />
                          <h2 className="subtitleSection divider">Lista de invitados</h2>
                          <p className="mainText greyBox">{commonUtil.getLabel(this.props.lables && this.props.lables.guestList, 'eventManagement.anonymous.guestList.description')}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 centeraligned">
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr11} _imgsrc={_imgsrc11} />
                          <h2 className="subtitleSection divider">Organizador de mesas</h2>
                          <p className="mainText greyBox">{commonUtil.getLabel(this.props.lables && this.props.lables.guestList, 'eventManagement.anonymous.tableOrganiser.description')}</p>
                        </div>
                      </div>

                      <div className="col-md-6" style={{ display: 'none' }}>
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr16} _imgsrc={_imgsrc16} />
                          <h2 className="subtitleSection divider">Lista de cooperación</h2>
                          <p className="mainText greyBox">Admistrar tu tareas por prioridad y por fechas de realizacion y rastrea todos los detalles mas importantes de la boda.</p>
                        </div>
                      </div>

                    </div>
                    <div className="row" style={{ display: 'none' }}>
                      <div className="col-md-6">
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr3} _imgsrc={_imgsrc3} />
                          <h2 className="subtitleSection divider">Lista de tareas</h2>
                          <p className="mainText greyBox">Admistrar tu tareas por prioridad y por fechas de realizacion y rastrea todos los detalles mas importantes de la boda.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr10} _imgsrc={_imgsrc10} />
                          <h2 className="subtitleSection divider">Encuesta sobre el evento</h2>
                          <p className="mainText greyBox">Admistrar tu tareas por prioridad y por fechas de realizacion y rastrea todos los detalles mas importantes de la boda.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ display: 'none' }}>
                      <div className="col-md-6">
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr4} _imgsrc={_imgsrc4} />
                          <h2 className="subtitleSection divider">Presupuesto y control de gastos</h2>
                          <p className="mainText greyBox">Admistrar tu tareas por prioridad y por fechas de realizacion y rastrea todos los detalles mas importantes de la boda.</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="toolsCard">
                          <Image imageAttr={imageAttr12} _imgsrc={_imgsrc12} />
                          <h2 className="subtitleSection divider">Calculadora de vinos y licores</h2>
                          <p className="mainText greyBox">Admistrar tu tareas por prioridad y por fechas de realizacion y rastrea todos los detalles mas importantes de la boda.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="createbutton">
                        <InputButton buttonAttr={webBtn} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment> :
            <React.Fragment>
              <div className="row toolsHome">
                {eventTargetterValueWap && eventTargetterValueWap.data ? <div dangerouslySetInnerHTML={{ __html: eventTargetterValueWap.data }} /> : ''}
              </div>
              <div className="row everyTool wapTool">
                <div className="toolsIntro">
                  <div className="websiteText">
                    <div className="row">
                      <img className="col-xs-3" src={commonUtil.getAssetURL() + '/images/admin/tools/09_pagina_web.svg'} alt="Liverpool" />
                      <h1 className="titleSection paginaWapTools col-xs-9">Página Web de mi evento</h1>
                    </div>
                    <p className="mainText">Construye tu propio sitio web para el gran evento, es fácil y rápido. Personalízalo, comparte información importante sobre el gran día, ¡sorprende a tus invitados!</p>
                  </div>
                  <div className="website"><img src={commonUtil.getAssetURL() + '/images/guest/tools/website.jpg'} alt="Liverpool" style={{ width: '100%' }} /></div>
                </div>
              </div>
              <div className="row everyTool wapTool">
                <div className="row">
                  <div className="toolsCard">
                    <Image imageAttr={imageAttr9} _imgsrc={_imgsrc9} />
                    <h2 className="subtitleSection">Lista de invitados</h2>
                  </div>
                  <div className="toolsCard">
                    <Image imageAttr={imageAttr8} _imgsrc={_imgsrc8} />
                    <h2 className="subtitleSection">Invitación virtual</h2>
                  </div>
                </div>
                <div className="row">
                  <div className="toolsCard centeraligned">
                    <Image imageAttr={imageAttr11} _imgsrc={_imgsrc11} />
                    <h2 className="subtitleSection">Organizador de mesas</h2>
                  </div>
                  <div className="col-md-6" style={{ display: 'none' }}>
                    <div className="toolsCard">
                      <Image imageAttr={imageAttr16} _imgsrc={_imgsrc16} />
                      <h2 className="subtitleSection">Lista de cooperación</h2>
                    </div>
                  </div>
                </div>
                <div className="row" style={{ display: 'none' }}>
                  <div className="toolsCard">
                    <Image imageAttr={imageAttr3} _imgsrc={_imgsrc3} />
                    <h2 className="subtitleSection">Lista de tareas</h2>
                  </div>
                  <div className="toolsCard">
                    <Image imageAttr={imageAttr10} _imgsrc={_imgsrc10} />
                    <h2 className="subtitleSection">Encuesta sobre el evento</h2>
                  </div>
                </div>
                <div className="row" style={{ display: 'none' }}>
                  <div className="toolsCard">
                    <Image imageAttr={imageAttr4} _imgsrc={_imgsrc4} />
                    <h2 className="subtitleSection">Presupuesto y control de gastos</h2>
                  </div>
                  <div className="toolsCard">
                    <Image imageAttr={imageAttr12} _imgsrc={_imgsrc12} />
                    <h2 className="subtitleSection">Calculadora de vinos y licores</h2>
                  </div>
                </div>
                <div>
                  <div className="createbutton">
                    <InputButton buttonAttr={wapBtn} />
                  </div>
                </div>
              </div>
            </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default ToolsForMyEvent;

